export { default as Vehicle } from '@components/vehicle/Vehicle';



// WEBPACK FOOTER //
// ./src/components/vehicle/index.ts